import { UsersService } from '@/service/UsersService'
import { GroupMemberRole } from './GroupMember'
import { MemberStatus } from './Groups'
import { TimeFrame } from './Leaderboard'
import Model from './Model'

export interface IUserSocials {
  facebook?: string
  twitter?: string
  instagram?: string
  linkedin?: string
  youtube?: string
  github?: string
  website?: string
}

// Group Member Roles
export enum UserRoles {
  ADMIN = 'ADMIN',
  CONTRIBUTOR = 'CONTRIBUTOR',
  OWNER = 'OWNER',
  MEMBER = 'MEMBER',
}

// Channel Member Roles
export enum ChannelRoles {
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
}

export enum ChannelVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export interface IUser {
  _id?: string
  locationId: string
  email: string
  contactId: string
  fullName: string
  password: string
  avatar?: string
  slug?: string
  bio?: string
  title?: string
  timeZone?: string
  socials?: IUserSocials
  isEmailVerified?: boolean
  lastLogin?: string
  location?: string
  role: GroupMemberRole
  status: MemberStatus
  groupId: string
  darkMode: boolean
  gamificationMeta?: {
    points?: number
    level?: number
    leaderboard?: Map<TimeFrame, number>
  }
  lastActivityAt?: string | Date
  lastVisitedAt?: string | Date
  joiningDate?: string | Date
  isChatDisabled?: boolean
  gokollabContactId?: string
}

export default class Users extends Model {
  constructor(payload: IUser) {
    super(payload, UsersService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get email(): string {
    return this._data.email
  }

  set email(email: string) {
    this._data.email = email
  }

  get contactId(): string {
    return this._data.contactId
  }

  set contactId(contactId: string) {
    this._data.contactId = contactId
  }

  get fullName(): string {
    return this._data.fullName
  }

  set fullName(fullName: string) {
    this._data.fullName = fullName
  }

  get password(): string {
    return this._data.password
  }

  set password(password: string) {
    this._data.password = password
  }

  get avatar(): string | undefined {
    return this._data.avatar
  }

  set avatar(avatar: string | undefined) {
    this._data.avatar = avatar
  }

  get slug(): string | undefined {
    return this._data.slug
  }

  set slug(slug: string | undefined) {
    this._data.slug = slug
  }

  get bio(): string | undefined {
    return this._data.bio
  }

  set bio(bio: string | undefined) {
    this._data.bio = bio
  }

  get title(): string | undefined {
    return this._data.title
  }

  set title(title: string | undefined) {
    this._data.title = title
  }

  get timeZone(): string | undefined {
    return this._data.timeZone
  }

  set timeZone(timeZone: string | undefined) {
    this._data.timeZone = timeZone
  }

  get socials(): IUserSocials | undefined {
    return this._data.socials
  }

  set socials(socials: IUserSocials | undefined) {
    this._data.socials = socials
  }

  get isEmailVerified(): boolean | undefined {
    return this._data.isEmailVerified
  }

  set isEmailVerified(isEmailVerified: boolean | undefined) {
    this._data.isEmailVerified = isEmailVerified
  }
}
